import { render, staticRenderFns } from "./ApprovedLeaseItem.vue?vue&type=template&id=525e6dd6&"
import script from "./ApprovedLeaseItem.vue?vue&type=script&lang=js&"
export * from "./ApprovedLeaseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports